module.exports = function (gsap, SplitText) {

    const splitText = document.querySelectorAll('.post-list__single__title h4');
    const servicesTitle = document.querySelectorAll('.single-service-sub__item__title');

    splitText.forEach((item) => {
        new SplitText(item, {
            type: "lines"
        })
    })

    servicesTitle.forEach((item) => {
        new SplitText(item, {
            type: "lines"
        })
    })
};